.v4-input {
  display: flex;
  flex-direction: column;
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
  color: var(--lab-ds-semantic-color-fg-default);
  max-width: 100%;
}

.v4-input .input-title-container {
  display: flex;
  flex-direction: column;
  gap: var(--lab-ds-semantic-selectable-space-gap-s);
}

.v4-input .title-text {
  text-align: left;
  font: var(--lab-ds-semantic-typography-heading-h8);
}

.v4-input.medium .title-text {
  font: var(--lab-ds-semantic-typography-heading-h7);
}

.v4-input .helper-text {
  display: flex;
  align-items: center;
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
  font: var(--lab-ds-semantic-typography-body-none-decoration-p3-regular);
}

.clean-visible {
  display: none;
}

.input-field {
  width: 95%;
  text-align: left;
}

.input-field .chip-selected {
  display: flex;
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
  width: 95%;
  overflow-x: auto;
  overflow-y: hidden;
}

.select-placeholder {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.input-field .chip-selected::-webkit-scrollbar {
  display: none;
}

.input-icon {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-style: solid;
  border-radius: var(--lab-ds-semantic-selectable-border-radius-xs);
  border-width: var(--lab-ds-semantic-selectable-border-width-m);
  border-color: var(--lab-ds-semantic-selectable-color-border-default);
  background-color: var(--lab-ds-semantic-selectable-color-bg-default);

  padding-top: var(--lab-ds-semantic-selectable-space-padding-s);
  padding-bottom: var(--lab-ds-semantic-selectable-space-padding-s);
  padding-left: var(--lab-ds-semantic-selectable-space-padding-m);
  padding-right: var(--lab-ds-semantic-selectable-space-padding-m);
  gap: var(--lab-ds-semantic-selectable-space-gap-xs);
  margin-bottom: 0;

  cursor: pointer;
}

.medium .input-icon {
  padding-top: var(--lab-ds-semantic-selectable-space-padding-sm);
  padding-bottom: var(--lab-ds-semantic-selectable-space-padding-sm);
}

.v4-input.chip-select.medium .input-icon {
  padding-top: var(--lab-ds-semantic-selectable-space-padding-s);
  padding-bottom: var(--lab-ds-semantic-selectable-space-padding-s);
}

.input-icon .input-field {
  color: var(--lab-ds-semantic-color-fg-enabled);
  font: var(--lab-ds-semantic-typography-body-none-decoration-p2-regular);
}

.options {
  font: var(--lab-ds-semantic-typography-body-none-decoration-p2-regular);
  position: relative;
  z-index: 20;
}

.hints {
  position: absolute;
  max-height: 21rem;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;

  border-style: solid;
  border-radius: var(--lab-ds-semantic-selectable-border-radius-xs);
  border-width: var(--lab-ds-semantic-selectable-border-width-m);

  gap: var(--lab-ds-semantic-selectable-space-gap-s);
  box-sizing: border-box;

  background-color: var(--lab-ds-semantic-selectable-color-bg-pure);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
  color: var(--lab-ds-semantic-color-fg-default);
}

.hints-container {
  display: flex;
  flex-direction: column;
  padding-right: var(--lab-ds-semantic-selectable-space-padding-m);
  padding-left: var(--lab-ds-semantic-selectable-space-padding-m);
  padding-bottom: var(--lab-ds-semantic-selectable-space-padding-s);
  padding-top: var(--lab-ds-semantic-selectable-space-padding-s);
  gap: var(--lab-ds-semantic-selectable-space-gap-s);
}

.hints .option {
  margin-top: 0.5rem;
}

.input-icon.active {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-m);
  background-color: var(--lab-ds-semantic-selectable-color-bg-default);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
}

.error .input-icon {
  background-color: var(--lab-ds-semantic-selectable-color-bg-default);
  border-color: var(--lab-ds-semantic-selectable-color-border-dark-error);
}

.icon.error {
  color: var(--lab-ds-semantic-selectable-color-bg-dark-error);
}

.error .helper-text {
  color: var(--lab-ds-semantic-selectable-color-bg-dark-error);
}

.v4-input:not(.disabled) .input-icon:focus-within {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-m);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
}

.v4-input:not(.disabled) .input-icon:hover {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-s);
  border-color: var(--lab-ds-semantic-selectable-color-primary-hover);
}

.input-icon:active {
  box-shadow: var(--lab-ds-semantic-selectable-shadow-m);
  border-color: var(--lab-ds-semantic-selectable-color-primary-press);
}

.icon {
  display: flex;
}

.v4-input.disabled .input-icon {
  background-color: var(--lab-ds-semantic-selectable-color-bg-disabled);
  border-color: var(--lab-ds-semantic-selectable-color-border-disabled);
  color: var(--lab-ds-semantic-selectable-color-bg-dark-success);
}

.v4-input.disabled .title-text {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .input-field {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .icon {
  color: var(--lab-ds-semantic-color-fg-disabled);
}

.v4-input.disabled .helper-text {
  color: var(--lab-ds-semantic-color-fg-disabled);
}
